<template>
  <v-container grid-list fluid>
    <v-layout row wrap>
      <v-flex v-if="user.role == 'employee'" xs12 class="mb-2">
        <ul class="info-listing subheading">
          <li><span>Shift Start: </span> {{ shift.startDatetime | moment("MM/DD/YY h:mma") }}</li>
          <li><span>Shift End: </span> {{ shift.endDatetime | moment("MM/DD/YY h:mma") }}</li>
          <li><span>Bonus:</span>
            <BonusList :shift="shift" :role="user.role" />
          </li>
          <li v-if="shift.details"><span>Shift Details: </span> {{ shift.details }}</li>
        </ul>
      </v-flex>

      <v-flex v-if="shift.changesProposed">
        <v-flex>
          <p class="red--text">
            The client has requested changes to this shift, but you must agree to them before they are committed. If you choose to deny the client's requests, they will be cancelled and the shift will remain unchanged.
          </p>
        </v-flex>
        <v-flex>
          <ul class="info-listing subheading">
            <li><span>New Shift Start: </span> <span class="red--text">{{ shift.proposedStartDatetime | moment("MM/DD/YY h:mma") }}</span></li>
            <li><span>New Shift End: </span> <span class="red--text">{{ shift.proposedEndDatetime | moment("MM/DD/YY h:mma") }}</span></li>
            <li><span>Bonus: </span><span class="red--text">{{ bonusAmount(shift.proposedStraightBonusAmount) }}</span></li>
            <li v-if="shift.details"><span>Shift Details: </span><span class="red--text"> {{ shift.proposedDetails }}</span></li>
          </ul>
          <v-layout row justify-end class="text-xs-right mb-4">
            <v-flex>
              <v-btn :disabled="decisionApiCallPending" :loading="decisionApiCallPending" @click="denyChanges" color="error">
                Deny Changes
              </v-btn>
              <v-btn :disabled="decisionApiCallPending" :loading="decisionApiCallPending" @click="approveChanges" color="success">
                Approve Changes
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: [
    'shift',
    'user',
  ],

  data() {
    return {
      decisionApiCallPending: false,
    }
  },

  methods: {
    bonusAmount(bonus) {
      const twoThirds = (2/3)
      const twoThirdsAmount = bonus * twoThirds
      return Math.trunc(twoThirdsAmount)
    },
    approveChanges () {
      this.decisionApiCallPending = true
      this.$store.dispatch('shifts/approveChanges', this.shift.id)
      .then(r => {
      })
      .finally(r => {
        this.decisionApiCallPending = false
      })
    },
    denyChanges () {
      this.decisionApiCallPending = true
      this.$store.dispatch('shifts/denyChanges', this.shift.id)
      .then(r => {
      })
      .finally(r => {
        this.decisionApiCallPending = false
      })
    },
  },

}
</script>
